import React from "react";
import { classNames } from "../../helpers/classNames";

const Radio = ({
  radioName,
  radioInputClass,
  isChecked,
  radioLabel,
  radioLableClass,
  value,
  className,
  onChange = () => {},
  id,
  ...props
}) => {
  return (
    <label htmlFor={id}>
      <div
        className={classNames(
          "relative overflow-hidden flex items-center",
          className
        )}
      >
        <input
          type="radio"
          name={radioName}
          className={
            "peer absolute top-0 left-0 w-5 h-5 opacity-0 z-10 cursor-pointer " +
            radioInputClass
          }
          checked={isChecked}
          onChange={onChange}
          value={value}
          id={id}
        />
        <div className="w-5 h-5 min-w-[20px] border border-slate-300 rounded-full flex items-center justify-center text-[10px] bg-shades-03 text-black/0 peer-checked:bg-white peer-checked:border-chestnut-rose peer-checked:text-chestnut-rose">
          <i className="fa-solid fa-fw fa-circle"></i>
        </div>
        {radioLabel && (
          <div
            className={
              "text-xs text-gable-green w-full font-CanelaDeck font-normal ml-3 " +
              radioLableClass
            }
          >
            {radioLabel}
          </div>
        )}
      </div>
    </label>
  );
};

export default Radio;
